// src/mocks/handlers/account/kycStatusHandler.ts

import { rest } from 'msw';
import { API_ENDPOINTS } from '@/services/api/endpoints';
import { VITE_MSW_BASE_URL } from '@/config';
import accountKYCStatusData from '@/mocks/data/account_kyc_status.json';
import { IKYCStatusResponse } from '@/domains/account/kyc/kyc.types';
import { isAccessTokenExpired } from '@/mocks/lib/authTokenUtils';

/* eslint-disable no-console */

export const kycStatusHandler = rest.get(
  `${VITE_MSW_BASE_URL}${API_ENDPOINTS.ACCOUNT_KYC_STATUS}`,
  (req, res, ctx) => {
    const customer_uuid = req.params.customer_uuid as string;

    if (isAccessTokenExpired()) {
      return res(ctx.status(401), ctx.json({ error: 'Access token expired' }));
    }

    const kycStatusRecord = accountKYCStatusData.find(
      (record) => record.uuid === customer_uuid,
    );

    console.log('KYC Status Record:', kycStatusRecord);

    if (!kycStatusRecord) {
      return res(ctx.status(404), ctx.json({ error: 'KYC status not found' }));
    }
    const responseStatus: IKYCStatusResponse = {
      status: kycStatusRecord.status as IKYCStatusResponse['status'],
      rfi_status:
        kycStatusRecord.rfi_status as IKYCStatusResponse['rfi_status'],
    };
    return res(ctx.status(200), ctx.json(responseStatus));
  },
);
